export default __webpack_public_path__ + "static/media/Sorcerer's Gauntlets of Imperial Assent.fded21ab.jpg";